<script setup lang="ts">
import { useTonConnectModal } from '@townsquarelabs/ui-vue'
import { usePuzzleChallengeLeaderboard } from '@/composables/game/leader-board'
import { usePuzzleChallenge } from '@/composables/game/challenges'
import PuzzleChallengeScoreImage from '@/assets/images/icons/timer-icon.webp'
import { useWalletConnect } from '@/composables/game/wallet-connect'
import { usePuzzlesOverlay } from '@/composables/game/puzzles'
import BaseChallengeModal from '@/components/modals/BaseChallengeModal.vue'
import PuzzleChallengeIcon from '@/assets/images/puzzle-challenge-icon.webp'
import PuzzleChallengeBackgroundImage from '@/assets/images/puzzle-challenge-modal-background.webp'

defineProps<{
	show: boolean
}>()
const emit = defineEmits(['hide'])

const { openPuzzlesOverlay } = usePuzzlesOverlay()

const { open } = useTonConnectModal()
const { rawAddress } = useWalletConnect()
const { formattedCountdown, puzzleChallenge } = usePuzzleChallenge()
const {
  getPuzzleChallengeLeaderboard,
  puzzleChallengeLeaderboard: players,
  currentPlayer,
} = usePuzzleChallengeLeaderboard()
</script>

<template>
  <BaseChallengeModal
    :show="show"
    :challenge="puzzleChallenge"
    :formatted-countdown="formattedCountdown"
    :on-cta-click="openPuzzlesOverlay"
    :get-leaderboard="getPuzzleChallengeLeaderboard"
    :players="players"
    :current-player="currentPlayer"
    background-color="bg-[linear-gradient(180deg,_#FF0533_0.01%,_#5A83A7_21.93%,_#000_36.54%)]"
    :background-image="PuzzleChallengeBackgroundImage"
    :main-image="PuzzleChallengeIcon"
    main-image-class="size-[225px] -translate-y-[100px]"
    main-image-background-class="size-[50px] bg-[#14F1FF] blur-[27px]"
    :with-stars="true"
    timer-background-class="bg-[linear-gradient(90deg,#FF0533_2.81%,#5A83A7_28.73%,#000_86.74%)]"
    title="Jigsaw challenge"
    description="Be the fastest to complete the jigsaw and claim rewards! Make sure to "
    :is-one-time-challenge="true"
    cta-text="Crack Jigsaw Puzzle"
    cta-challenge-done-text="Jigsaw Cracked"
    rule-card-line1="Reveal"
    rule-card-line2="Image"
    :score-image="PuzzleChallengeScoreImage"
    :is-score-in-milliseconds="true"
    :is-rule-card-clickable="true"
    @hide="emit('hide')"
  >
    <template #ruleContent>
      <div class="flex flex-col items-center gap-y-3">
        <span>How it works:</span>
        <span>
          • Reveal the image behind the
          <span
            :class="{'pointer-events-none': !!currentPlayer?.score, 'border-b border-current': !currentPlayer?.score}"
            @click="() => openPuzzlesOverlay()"
          >
            jigsaw puzzle
          </span>
          as quickly as you can to climb the leaderboard
        </span>
        <span>
          • Make sure to
          <span
            :class="{'pointer-events-none': !!rawAddress, 'border-b border-current': !rawAddress}"
            @click="open"
          >
            connect
          </span>
          your wallet to participate.
        </span>
      </div>
    </template>
  </BaseChallengeModal>
</template>
